import { Headline, Paragraph, Image, Button } from 'Common';
import Style from './SleepPromoCard.style';

export const SleepPromoCard = ({ course, image }) => {
  return (
    <Style className="sleep-card">
      <div className="sleep-left-col text-center">
        <Paragraph className="course-tag extra-small-bold">{course.tag}</Paragraph>
        <Headline level={4} className="course-title">
          {course.title}
        </Headline>
        <Paragraph className="sleep-description small">{course.description}</Paragraph>
        <Button className="sleep-button d-md-none" variant="primary" href={course.route} target="_blank" color="blue">
          {course.button}
        </Button>
      </div>
      <div className="sleep-right-col">
        <Image src={image} alt={course.altTag} className="sleep-image" />
        <Button className="sleep-button d-none d-md-flex" variant="primary" href={course.route} target="_blank" color="blue">
          {course.button}
        </Button>
      </div>
    </Style>
  );
};


